<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <div class="header-button" />
    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="warningLogs"
      resource="worker"
    >
      <el-table-column
        prop="bike_no"
        label="车辆编号"
        align="center"
        width="170"
      />
      <el-table-column
        prop="box_no"
        label="中控编号"
        align="center"
        width="170"
      />
      <el-table-column
        prop="created_at"
        label="时间"
        align="center"
        width="180"
      />
      <!-- <el-table-column
                prop="bike_no"
                label="车牌号"
                align="center"
                width="130"
                show-overflow-tooltip
              /> -->
      <el-table-column
        prop="type_name"
        label="报警类型"
        align="center"
        width="200"
        show-overflow-tooltip
      />
      <el-table-column
        prop="source"
        label="报警来源"
        align="center"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="body"
        label="报警日志"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-popover
            trigger="click"
            placement="top"
          >
            <pre> {{ scope.row.body }}</pre>
            <div
              slot="reference"
              class="name-wrapper"
            >
              {{ scope.row.body }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getBoxWarningLogs, getWarningType } from "@/api/box";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "type",
          label: "类型",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "bike_no",
          label: "车牌号"
        },
        {
          field: "box_no",
          label: "中控号"
        },
        {
          type: "time-between",
          field: "created_time_between",
          label1: "创建时间-开始",
          label2: "创建时间-结束"
        }
      ],
      warningLogs: [],
      page: null,
      first_blood: true,
      areas: [],
      detailQuestion: "",
      dialogVisible: false
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(41, newVal);
        const {
          data: { data, meta }
        } = await getBoxWarningLogs(newVal.query);
        this.warningLogs = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    // console.log(11)
    const [{ data: warningTypes }] = await Promise.all([getWarningType()]);

    // this.areas.push.apply(this.areas, areas)
    this.search[0].options.push.apply(this.search[0].options, warningTypes);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  methods: {}
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.limitwidth {
  width: 40%;
  margin-right: 10px;
}
</style>
